const data = {
  rate: [{
    prop: 'categoryName',
    label: '分类',
    width: '100'
  }, {
    prop: 'categoryName2',
    label: '考核项目',
    width: '100'
  }, {
    prop: 'ruleName',
    label: '考核内容',
    width: '100'
  }, {
    prop: 'description',
    label: '考核描述',
    width: '120'
  }, {
    prop: 'isIn',
    label: '是否纳入考核',
    width: '120',
    slot: 'isin'
  }],
  assessment: [{
    prop: 'title',
    label: '考核内容',
    width: '170'
  }, {
    prop: 'categoryId',
    label: '分类',
    slot: 'category'
  }, {
    prop: 'reTime',
    label: '响应时间',
    slot: 'xiangying'
  }, {
    prop: 'score',
    label: '扣分',
    width: '70',
    slot: 'koufen'
  }, {
    prop: 'isIn',
    label: '是否纳入考核',
    width: '100',
    slot: 'isin'
  }, {
    prop: 'description',
    label: '描述',
    width: '200'
  }, {
    prop: 'enable',
    label: '应用',
    width: '70',
    slot: 'yingyong'
  }, {
    prop: 'id',
    label: '操作',
    width: '70',
    slot: 'action'
  }],
  autoDown: [{
    prop: 'title',
    label: '考核内容',
    width: '170'
  }, {
    prop: 'categoryId',
    label: '分类',
    slot: 'category'
  }, {
    prop: 'score',
    label: '扣分',
    width: '70',
    slot: 'koufen'
  }, {
    prop: 'isIn',
    label: '是否纳入考核',
    width: '100',
    slot: 'isin'
  }, {
    prop: 'qualified',
    label: '不合格',
    width: '70',
    slot: 'qualified'
  }, {
    prop: 'delist',
    label: '触发退市',
    slot: 'delist'
  }, {
    prop: 'description',
    label: '描述',
    width: '200'
  }, {
    prop: 'enable',
    label: '应用',
    width: '70',
    slot: 'yingyong'
  }, {
    prop: 'id',
    label: '操作',
    width: '70',
    slot: 'action'
  }],
  rule: {
    exceedAssessSwitch: [{
      required: true,
      message: '是否超额投放纳入考核',
      trigger: 'change'
    }],
    exceedDeductRule: [{
      required: true,
      message: '请输入超额投放扣分数',
      trigger: 'blur'
    }],
    exceedQuitSwitch: [{
      required: true,
      message: '是否超额投放触发退市',
      trigger: 'change'
    }],
    exceedQuitRule: [{
      required: true,
      message: '请输入退市条件',
      trigger: 'blur'
    }],
    exceedDescribe: [{
      required: true,
      message: '请输入超额投放考核描述',
      trigger: 'blur'
    }],
    dispatchDescribe: [{
      required: true,
      message: '请输入调度任务考核描述',
      trigger: 'blur'
    }],
    finishAssessSwitch: [{
      required: true,
      message: '完结率是否纳入考核',
      trigger: 'change'
    }],
    finishRate: [{
      required: true,
      message: '请输入完结率',
      trigger: 'blur'
    }],
    finishScore: [{
      required: true,
      message: '请输入未完结扣分数',
      trigger: 'blur'
    }],
    finishDescribe: [{
      required: true,
      message: '请输入完结率描述考核描述',
      trigger: 'blur'
    }],
    categoryId: [{
      required: true,
      message: '请选择考核分类id',
      trigger: 'change'
    }],
    title: [{
      required: true,
      message: '请输入规则名称',
      trigger: 'blur'
    }],
    re_time: [{
      required: true,
      message: '请输入响应时间',
      trigger: 'blur'
    }],
    score: [{
      required: true,
      message: '请输入扣分单位',
      trigger: 'blur'
    }],
    unit: [{
      required: true,
      message: '请输入单位',
      trigger: 'blur'
    }],
    isIn: [{
      required: true,
      message: '是否纳入考核',
      trigger: 'change'
    }],
    description: [{
      required: true,
      message: '请输入考核描述',
      trigger: 'blur'
    }],
    qualified: [{
      required: true,
      message: '是否触发不合格',
      trigger: 'change'
    }],
    qualifiedScore: [{
      required: true,
      message: '请输入触发不合格的分数',
      trigger: 'blur'
    }],
    delist: [{
      required: true,
      message: '是否触发退市',
      trigger: 'change'
    }],
    delistScore: [{
      required: true,
      message: '请输入触发退市的分数',
      trigger: 'blur'
    }],
  }
}

export default data
